import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e8ca1a5&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e8ca1a5')) {
      api.createRecord('2e8ca1a5', component.options)
    } else {
      api.reload('2e8ca1a5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2e8ca1a5&", function () {
      api.rerender('2e8ca1a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/zhaopin/index.vue"
export default component.exports